// Starter story library — bilingual, read-along, with printable activity notes.
export const STORIES = [
  {
    slug: "the-little-paper-plane",
    category: "kindness",
    minutes: 4,
    title: { en: "The Little Paper Plane", zh: "小纸飞机" },
    desc: { en: "A paper plane learns that helping others helps it fly higher.", zh: "一架小纸飞机明白了，帮助别人能让自己飞得更高。" },
    cover: "#E8F5FF",
    pages: [
      {
        en: "High above LUMORA town, a little paper plane wished it could fly as high as the big kites.",
        zh: "在 LUMORA 小镇的上空，一架小纸飞机多么希望能飞得像大风筝一样高。",
      },
      {
        en: "One windy day, it spotted a lost firefly who couldn't find her way home.",
        zh: "一个刮风的日子，它看见一只迷路的萤火虫，找不到回家的路。",
      },
      {
        en: "The little plane carried the firefly gently, up and over the glowing hills.",
        zh: "小飞机轻轻地托着萤火虫，越过发着微光的山丘。",
      },
      {
        en: "When the firefly was safely home, she lit the plane's path — and together they soared higher than ever.",
        zh: "当萤火虫安全到家，她点亮了飞机的航道——它们一起飞得比以往任何时候都高。",
      },
    ],
    activity: {
      en: "Activity: Draw your own paper plane and write one kind thing you did this week.",
      zh: "活动：画出你自己的纸飞机，并写下这一周你做过的一件善事。",
    },
  },
  {
    slug: "luma-counts-the-stars",
    category: "mathematics",
    minutes: 3,
    title: { en: "Luma Counts the Stars", zh: "露玛数星星" },
    desc: { en: "Luma the bunny counts the night sky and discovers patterns.", zh: "小兔露玛数着夜空的星星，发现了规律。" },
    cover: "#082B66",
    pages: [
      {
        en: "Luma the blue bunny loved the night sky. 'One, two, three…' she counted the twinkling stars.",
        zh: "蓝兔露玛喜欢夜空。“一、二、三……” 她数着闪烁的星星。",
      },
      {
        en: "She noticed the brightest stars came in groups of five. Five here, five there!",
        zh: "她发现最亮的星星总是五颗一组。这里五颗，那里五颗！",
      },
      {
        en: "By counting in fives, Luma reached one hundred faster than ever. Patterns made counting magic.",
        zh: "按五个一数，露玛比以往更快数到了一百。规律让数数变得神奇。",
      },
    ],
    activity: {
      en: "Activity: Count a group of objects at home in fives. How fast can you reach twenty?",
      zh: "活动：把家里的一堆物品按五个一数。你能多快数到二十？",
    },
  },
  {
    slug: "the-sharing-garden",
    category: "kindness",
    minutes: 4,
    title: { en: "The Sharing Garden", zh: "分享花园" },
    desc: { en: "Three friends grow a garden that feeds the whole neighborhood.", zh: "三个朋友种出一座花园，喂饱了整个社区。" },
    cover: "#45C878",
    pages: [
      {
        en: "Blue, Sky, and Rosy planted seeds in a small patch of soil near the treehouse library.",
        zh: "小蓝、小天和小蔷薇在树屋图书馆旁的一小块土地上播下了种子。",
      },
      {
        en: "They watered the seeds every morning and shared the work, taking turns.",
        zh: "他们每天早晨浇水，轮流分担，共同劳动。",
      },
      {
        en: "Soon the garden burst with carrots and berries — far more than three friends could eat.",
        zh: "不久，花园里长满了胡萝卜和浆果——远远超过三个朋友能吃完的量。",
      },
      {
        en: "So they shared the harvest with everyone in town. A shared garden grows the biggest smiles.",
        zh: "于是他们把收成分享给镇上的每个人。分享的花园，长出最灿烂的笑容。",
      },
    ],
    activity: {
      en: "Activity: Name one thing you could share with a friend or neighbor today.",
      zh: "活动：说出今天你可以和朋友或邻居分享的一样东西。",
    },
  },
  {
    slug: "the-brave-little-cloud",
    category: "science",
    minutes: 3,
    title: { en: "The Brave Little Cloud", zh: "勇敢的小云朵" },
    desc: { en: "A shy cloud discovers how rain helps the whole world grow.", zh: "一朵害羞的小云，发现雨水如何帮助整个世界成长。" },
    cover: "#147DEB",
    pages: [
      {
        en: "A small cloud named Nimbus was too shy to rain. 'What if nobody needs me?' he worried.",
        zh: "有一朵名叫尼姆的小云，害羞得不敢下雨。“万一没人需要我呢？” 他担心地想。",
      },
      {
        en: "Below, the fields were dry and the flowers drooped in the sun.",
        zh: "下面的田野干涸了，花朵在阳光下低垂着头。",
      },
      {
        en: "Taking a deep breath, Nimbus let his raindrops fall. The fields drank happily and turned green.",
        zh: "尼姆深吸一口气，让雨滴落下。田野开心地畅饮，变成一片翠绿。",
      },
    ],
    activity: {
      en: "Activity: Draw the water cycle — sun, cloud, rain, and back again.",
      zh: "活动：画出水循环——太阳、云、雨，再回到起点。",
    },
  },
];

export function getStory(slug) {
  return STORIES.find((s) => s.slug === slug);
}

// Printable parent/teacher resources (generated in-browser, no external files fabricated).
export const RESOURCES = [
  {
    id: "alphabet-sheet",
    title: { en: "Alphabet Tracing Sheet", zh: "字母描写练习单" },
    desc: { en: "A printable sheet to practice writing letters A–Z.", zh: "可打印的字母 A–Z 书写练习单。" },
    kind: "printable",
  },
  {
    id: "counting-sheet",
    title: { en: "Counting 1–20 Worksheet", zh: "1–20 数数练习单" },
    desc: { en: "Count and color groups of objects from 1 to 20.", zh: "数一数、涂一涂 1 到 20 的物品。" },
    kind: "printable",
  },
  {
    id: "kindness-journal",
    title: { en: "Kindness Journal Page", zh: "善意日记页" },
    desc: { en: "A gentle page for children to record kind acts.", zh: "给孩子记录善举的温馨日记页。" },
    kind: "printable",
  },
];
